import React from 'react'

import Box from 'components_new/atoms/Box'

import ChatAvatar from './ChatAvatar'

const Avatar = (props: { size?: number; active?: boolean }) => {
  const { size, active } = props

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flex: '0 0 auto',
        height: size ?? 32,
        justifyContent: 'center',
        transition: 'ease 0.5s all',
        width: size ?? 32
      }}
    >
      <ChatAvatar active={active} />
    </Box>
  )
}

export default Avatar
